enum PhishingShareMethod {
  Publish = 'Publish',
  CopyLink = 'Copy Link',
  Revalidating = 'Revalidating',
  Preview = 'Preview',
}

export { PhishingShareMethod };
